import React from "react";
import { formatBrDate } from "../../../services/formatResponses/date";
import { Clock, RefreshCw, X } from "lucide-react";

import { Table } from "../../../components/ui/Table";
import { CrmPetController } from "../../../services/controllers/crmPet";
import { formatTutorName } from "../../../services/functions";
import { useCrmPet } from "../../../store/crmPet/useCrmPet";


export function ContactHistoryModal() {
  const CCrmPet = CrmPetController();
  const contactHistory = useCrmPet((state) => state.data.contactHistory);

  if (!contactHistory.show) return null;

  const tutorName = formatTutorName(contactHistory.pet?.customerName);

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="contact-history-title"
    >
      <div className="flex max-h-[92vh] w-full max-w-5xl flex-col overflow-hidden rounded-lg bg-white shadow-2xl">
        <div className="flex items-center justify-between border-b border-zinc-200 px-6 py-4">
          <div>
            <p id="contact-history-title" className="m-0 flex items-center gap-2 text-sm font-semibold text-gray-800">
              <Clock size={18} className="text-scale-500" />
              Histórico de contatos de {tutorName}
            </p>
            <p className="m-0 mt-1 text-xs text-gray-500">Contatos consolidados por cliente, pets e réguas</p>
          </div>
          <button
            type="button"
            onClick={CCrmPet.closeContactHistory}
            aria-label="Fechar histórico de contatos"
            className="cursor-pointer border-none bg-transparent p-1 text-gray-400 hover:text-gray-600"
          >
            <X size={18} />
          </button>
        </div>

        <div className="flex-1 overflow-auto px-6 py-5">
          {contactHistory.loading ? (
            <div className="flex items-center justify-center gap-2 py-16 text-sm text-gray-400">
              <RefreshCw size={16} className="animate-spin" />
              Carregando histórico...
            </div>
          ) : contactHistory.items.length === 0 ? (
            <div className="py-16 text-center text-sm text-gray-400">
              Nenhum contato realizado para este cliente.
            </div>
          ) : (
            <Table.Root name="crm-pet-contact-history">
              <Table.Header
                columns={[
                  "Data:minmax(145px, 0.8fr)",
                  "Responsável:minmax(120px, 0.8fr)",
                  "Pets:minmax(130px, 1fr)",
                  "Réguas:minmax(180px, 1.2fr)",
                  "Ação:minmax(140px, 1fr)",
                  "Mensagem:minmax(240px, 2fr)",
                ]}
              />
              <Table.Content>
                {contactHistory.items.map((contact, index) => (
                  <Table.Line key={contact._id || `${contact.contactedAt}-${index}`}>
                    <Table.Item>{formatBrDate(contact.contactedAt, true)}</Table.Item>
                    <Table.Item>{contact.responsibleName}</Table.Item>
                    <Table.Item>{contact.pets.map((pet) => pet.petName || "Sem nome").join(", ") || "-"}</Table.Item>
                    <Table.Item>
                      {contact.selections.map((selection) => (
                        selection.label === selection.ruleLabel
                          ? selection.ruleLabel
                          : `${selection.ruleLabel} · ${selection.label}`
                      )).join(", ") || "-"}
                    </Table.Item>
                    <Table.Item>{contact.status === "CONTACT_RESET" ? "Desmarcação manual" : contact.status === "MANUAL_CONTACT" ? "Contato manual" : "Abertura do WhatsApp"}</Table.Item>
                    <Table.Item>
                      <span className="line-clamp-3 px-2 text-xs" title={contact.message}>{contact.message || "-"}</span>
                    </Table.Item>
                  </Table.Line>
                ))}
              </Table.Content>
            </Table.Root>
          )}
        </div>

        <div className="flex justify-end border-t border-zinc-200 bg-gray-50 px-6 py-4">
          <button
            type="button"
            onClick={CCrmPet.closeContactHistory}
            className="cursor-pointer rounded border-none bg-scale-500 px-4 py-2 text-sm font-medium text-white hover:bg-scale-600"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}
